'use strict';

var createEvents = require('./create-events');
var registerEvents = require('./register-events');
var getDataLayer = require('./get-data-layer');

var createMiddleware = function createMiddleware(eventDefinitionsMap) {
  var extensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (store) {
    return function (next) {
      return function (action) {
        if (!eventDefinitionsMap[action.type]) {
          return next(action);
        }

        var dataLayer = getDataLayer(window, extensions.customDataLayer);

        if (dataLayer === undefined) {
          return next(action);
        }

        var prevState = store.getState();

        var events = createEvents(eventDefinitionsMap[action.type], prevState, action);
        registerEvents(events, dataLayer, prevState, extensions, action);

        return next(action);
      };
    };
  };
};

module.exports = createMiddleware;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/create-middleware.js
// module id = 330
// module chunks = 0